import Vue from 'vue';
import store from '../store/store';

export default new Vue({
  store,
  data() {
    return {
      GuestLoginPageAccess: [
        {
          name: 'Overview and Payment',
          id: 766,
          guestLoginaccess: true,
        },
        {
          name: 'Contact details',
          id: 769,
          guestLoginaccess: false,
        },
        {
          name: 'Trip details',
          id: 767,
          guestLoginaccess: false,
        },
        {
          name: 'Passport details',
          id: 768,
          guestLoginaccess: true,
        },
        {
          name: 'Holiday information pack',
          id: 770,
          guestLoginaccess: true,
        },
        {
          name: 'Experiences',
          id: 771,
          guestLoginaccess: true,
        },
        {
          name: 'Order wine',
          id: 'OrderWine',
          guestLoginaccess: true,
        },
        {
          name: 'Dashboard',
          id: 82,
          guestLoginaccess: false,
        },
        {
          name: 'Personal Profile',
          id: 116,
          guestLoginaccess: true,
        },
        {
          name: 'Subscription Preferences',
          id: 84,
          guestLoginaccess: false,
        },
        {
          name: 'My Bookings',
          id: 83,
          guestLoginaccess: true,
        },
        {
          name: 'Guest Logins',
          id: 117,
          guestLoginaccess: false,
        },
        {
          name: 'Logout',
          id: 'logout',
          guestLoginaccess: true,
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.getters['users/loggedInUser'];
    },
  },
  created() {
    this.$on('clientAreaMounted', this.checkSecurity);
  },

  methods: {
    checkSecurity(pageid) {
      if (this.user.coSignIn) {
        const noaccess = this.GuestLoginPageAccess.find((p) => p.id === pageid && p.guestLoginaccess === false);
        if (noaccess) {
          // redirect to My Bookings Page
          // this.$router.push({ path: this.$store.getters['applinks/getLink']('page', 83).url })
          document.location.href = this.$store.getters['applinks/getLink']('page', 83).url;
        }
      }
    },
  },
});
